var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btnradio",class:{
    active: _vm.active,
  },attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"btnradio-indicator"}),_c('div',{staticClass:"btnradio-text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }